(function () {
  function initCarousel(carousel, dotsContainer) {
    const slides = Array.from(carousel.children);

    // Build dots
    dotsContainer.innerHTML = "";
    slides.forEach((_, i) => {
      const dot = document.createElement("button");
      dot.className = "dot" + (i === 0 ? " active" : "");
      dot.type = "button";
      dot.dataset.index = i;
      dotsContainer.appendChild(dot);
      dot.addEventListener("click", () => scrollToIndex(i));
    });

    // Cache slide start positions once per layout
    let positions = [];
    function measure() { positions = slides.map(s => s.offsetLeft); }

    // Nearest slide for a given scrollLeft (binary search)
    function indexFromScrollLeft(x) {
      let lo = 0, hi = positions.length - 1;
      while (lo < hi) {
        const mid = (lo + hi) >> 1;
        if (positions[mid] <= x) lo = mid + 1; else hi = mid;
      }
      const i = Math.max(0, Math.min(positions.length - 1, lo));
      return (i > 0 && Math.abs(positions[i] - x) > Math.abs(positions[i - 1] - x)) ? i - 1 : i;
    }

    // Smooth programmatic scroll without fighting scroll-snap
    let animId = 0;
    function animateTo(targetLeft, duration = 360) {
      animId++;
      const thisAnim = animId;
      const start = carousel.scrollLeft;
      const delta = targetLeft - start;
      if (Math.abs(delta) < 1) { carousel.scrollLeft = targetLeft; return; }

      const prevSnap = carousel.style.scrollSnapType;
      carousel.style.scrollSnapType = "none";
      const t0 = performance.now();
      const ease = t => 1 - Math.pow(1 - t, 3);

      function step(now) {
        if (thisAnim !== animId) return;
        const t = Math.min(1, (now - t0) / duration);
        carousel.scrollLeft = start + delta * ease(t);
        if (t < 1) requestAnimationFrame(step);
        else {
          carousel.scrollLeft = targetLeft;
          carousel.style.scrollSnapType = prevSnap || "x mandatory";
          // align to exact slide start
          const idx = indexFromScrollLeft(carousel.scrollLeft);
          carousel.scrollLeft = positions[idx];
        }
      }
      requestAnimationFrame(step);
    }

    function scrollToIndex(i) {
      const target = positions[i] ?? 0;
      animateTo(target);
    }

    // Dots active state
    let active = -1;
    function setActive(i) {
      if (i === active) return;
      active = i;
      dotsContainer.querySelectorAll(".dot").forEach((d, idx) => {
        d.classList.toggle("active", idx === i);
      });
    }

    // Scroll sync (cheap, rAF throttled)
    let ticking = false;
    carousel.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setActive(indexFromScrollLeft(carousel.scrollLeft));
        ticking = false;
      });
    }, { passive: true });

    // Measure on load/resize
    function init() { measure(); setActive(indexFromScrollLeft(carousel.scrollLeft)); }

    new ResizeObserver(() => {
      const idx = indexFromScrollLeft(carousel.scrollLeft);
      measure();
      animateTo(positions[idx] || 0, 0);
      setActive(idx);
    }).observe(carousel);

    const imgs = carousel.querySelectorAll("img");
    let pending = imgs.length;
    if (pending) {
      imgs.forEach(img => {
        if (img.complete) { if (--pending === 0) init(); }
        else img.addEventListener("load", () => { if (--pending === 0) init(); }, { once: true });
      });
    } else { init(); }
  }

  // Initialize ALL carousels on the page
  document.querySelectorAll(".js-carousel-wrap").forEach((wrap) => {
    const carousel = wrap.querySelector(".js-carousel");
    const dots = wrap.querySelector(".js-dots") || document.createElement("div");
    if (!wrap.querySelector(".js-dots")) { dots.className = "js-dots"; wrap.appendChild(dots); }
    if (carousel) initCarousel(carousel, dots);
  });

  // Optional: per-carousel control buttons (use data attributes)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-carousel-action]");
    if (!btn) return;
    const wrap = btn.closest(".js-carousel-wrap");
    const carousel = wrap?.querySelector(".js-carousel");
    if (!carousel) return;

    if (btn.dataset.carouselAction === "toggleSnap") {
      carousel.classList.toggle("snap");
    } else if (btn.dataset.carouselAction === "toggleDirection") {
      carousel.classList.toggle("vertical");
      carousel.style.scrollSnapType = carousel.classList.contains("vertical") ? "y mandatory" : "x mandatory";
    }
  });
})();